import { render, staticRenderFns } from "./PromoteMonthlyGoals.vue?vue&type=template&id=b00d1d88"
import script from "./PromoteMonthlyGoals.vue?vue&type=script&lang=js"
export * from "./PromoteMonthlyGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports